import { redirectToUrl } from './redirect-to-url';
import { reload } from './reload';

export default {
  redirectToUrl,
  reload,
};
